/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackDownloadRequestBody
 */
export interface TrackDownloadRequestBody {
    /**
     * City where the download occurred
     * @type {string}
     * @memberof TrackDownloadRequestBody
     */
    city?: string;
    /**
     * Region where the download occurred
     * @type {string}
     * @memberof TrackDownloadRequestBody
     */
    region?: string;
    /**
     * Country where the download occurred
     * @type {string}
     * @memberof TrackDownloadRequestBody
     */
    country?: string;
}

/**
 * Check if a given object implements the TrackDownloadRequestBody interface.
 */
export function instanceOfTrackDownloadRequestBody(value: object): value is TrackDownloadRequestBody {
    let isInstance = true;

    return isInstance;
}

export function TrackDownloadRequestBodyFromJSON(json: any): TrackDownloadRequestBody {
    return TrackDownloadRequestBodyFromJSONTyped(json, false);
}

export function TrackDownloadRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackDownloadRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': !exists(json, 'city') ? undefined : json['city'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'country': !exists(json, 'country') ? undefined : json['country'],
    };
}

export function TrackDownloadRequestBodyToJSON(value?: TrackDownloadRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'region': value.region,
        'country': value.country,
    };
}

